import { render } from "./DocFileUpload.vue?vue&type=template&id=8a3467e4"
import script from "./DocFileUpload.vue?vue&type=script&lang=js"
export * from "./DocFileUpload.vue?vue&type=script&lang=js"

import "./DocFileUpload.vue?vue&type=style&index=0&id=8a3467e4&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__